/**
 * Run callback when document DOM content is ready
 *
 * @param {function} callback
 */
function onDOMContentLoaded(callback) {
    if (document.readyState !== 'loading') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
}

/**
 * Run callback when all window content has loaded
 *
 * @param {function} callback
 */
function onWindowLoad(callback) {
    if (document.readyState === 'complete') {
        callback();
    } else {
        window.addEventListener('load', callback);
    }
}

export {
    // Export onDOMContentLoaded as default to cover old uses of onReady
    onDOMContentLoaded as default,
    onDOMContentLoaded,
    onWindowLoad
};
